/**
 * @title Mobile Navigation Menu
 * @description Logic for managing the mobile navigation menu.
 */
function mobileNavigationMenu() {
  const header = document.getElementById("header").getElementsByClassName("container")[0]
  const menuOpenButton = document.getElementById("menu-open-button")
  const menuCloseButton = document.getElementById("menu-close-button")
  const menuPanel = document.getElementById("menu-panel")
  const menuPanelHeader = document.getElementById("menu-panel-header")
  const menuPanelLinks = menuPanel.getElementsByTagName("a")
  const menuPanelTransitionOrigin = menuPanel.getAttribute("js-transition-origin")
  const menuPanelTransitionEffect = menuPanel.getAttribute("js-transition-effect")

  menuPanelHeader.style.height = header.clientHeight + "px"

  let menuClassesSlide = []
  let menuClassesFade = ["opacity-0", "pointer-events-none"]

  if (menuPanelTransitionEffect == "slide") {
    switch (menuPanelTransitionOrigin) {
      case "top":
        menuClassesSlide = ["-translate-y-full", "pointer-events-none"]
        break
      case "left":
        menuClassesSlide = ["-translate-x-full", "pointer-events-none"]
        break
      default:
        menuClassesSlide = ["translate-x-full", "pointer-events-none"]
        break
    }
  }

  function toggleMenu() {
    if (menuPanelTransitionEffect == "slide") menuClassesSlide.map((v) => menuPanel.classList.toggle(v))
    if (menuPanelTransitionEffect == "fade") menuClassesFade.map((v) => menuPanel.classList.toggle(v))
  }

  if (menuOpenButton && menuPanel) {
    menuOpenButton.addEventListener("click", function () {
      toggleMenu()
    })
  }

  if (menuCloseButton && menuPanel) {
    menuCloseButton.addEventListener("click", function () {
      toggleMenu()
    })
  }

  for (let i = 0; i < menuPanelLinks.length; i++) {
    menuPanelLinks[i].addEventListener("click", function () {
      toggleMenu()
    })
  }
}

export default mobileNavigationMenu
